import type { FormValues } from "@/widgets/classic-form/form";
import type { NameFieldGroup } from "@/entities/form-metadata";
import { NameAssertion } from "@/entities/form-metadata";

export const populateNameFields = ({
    fieldGroup,
    dataModel,
    formValuesNameData,
    matchAllTermsExactly,
}: {
    fieldGroup: NameFieldGroup;
    dataModel: FormValues;
    formValuesNameData: FormValues["name"];
    matchAllTermsExactly: boolean;
}) => {
    const { name } = dataModel;
    const { isFirstNameExactnessEnabled, isSurnameExactnessEnabled } = fieldGroup.fields.reduce(
        (acc, field) => {
            const {
                assertion,
                features: { showExactness },
            } = field;
            if (assertion === NameAssertion.GivenName) {
                acc.isFirstNameExactnessEnabled = showExactness ?? true;
            } else if (assertion === NameAssertion.Surname) {
                acc.isSurnameExactnessEnabled = showExactness ?? true;
            }
            return acc;
        },
        { isFirstNameExactnessEnabled: true, isSurnameExactnessEnabled: true },
    );
    const { givenName, givenNameExactness, secondSurname, surname, surnameExactness } = name;
    // @ts-ignore FIXME
    const newData: FormValues["name"] = {
        givenName,
        secondSurname,
        surname,
    };
    if (isFirstNameExactnessEnabled) {
        // Preserve user preference isExact when MAT is off; force true when MAT is on.
        // Note: MAT toggle uses setFieldValue directly (useToggleNameExactness), not this function.
        newData.givenNameExactness = {
            ...givenNameExactness,
            isExact: matchAllTermsExactly || givenNameExactness.isExact,
        };
    }
    if (isSurnameExactnessEnabled) {
        newData.surnameExactness = {
            ...surnameExactness,
            isExact: matchAllTermsExactly || surnameExactness.isExact,
        };
    }
    Object.assign(formValuesNameData, newData);
};
